import { Box, Button, Grid, Table, TableBody, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { object, string } from "yup";
import CheckboxCmp from "../../components/checkbox/CheckboxCmp";
import AutoCompleteSearch from "../../components/dropdown/AutoCompleteSearch";
import SupplierUsersTable from "../../components/table/SupplierUsersTable";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { GetCitiesResponse } from "../../models/basicInformation.model";
import { GetCities } from "../../services/basicInformation.service";

interface Props {
  newUser: any;
  setNewUser: any;
}

const SupplierUserForm = ({ newUser, setNewUser }: Props) => {
  const [cities, setCities] = useState<GetCitiesResponse[]>([]);
  const [cityIds, setCityIds] = useState<string>();
  const [city, setCity] = useState<any[]>([]);
  const [isFullAccess, setFullAccess] = useState(false);
  const [tempUsers, setTempUsers] = React.useState<any[]>([]);
  const [delUserId, setDelUserId] = React.useState<number>();
  const checkboxRef = useRef<any>(null);

  const [keyState, setKeyState] = useState<number>(1);
  const initialValues: any = {
    firstName: "",
    lastName: "",
    mobileNo: "",
    fullAccess: false,
    city: "",
  };
  const usersValidation = object().shape({
    firstName: string()
      .ensure()
      .required("لطفا نام را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا نام را صحیح وارد نمایید")

      .max(250, "نام  نباید بیشتر از ۲۵۰ باشد"),
    lastName: string()
      .ensure()
      .required("لطفا نام خانوادگی را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا نام خانوادگی را صحیح وارد نمایید")

      .max(250, "نام و نام خانوادگی نباید بیشتر از ۲۵۰ باشد"),

    mobileNo: string()
      .ensure()
      .required("لطفا شماره موبایل را وارد نمایید.")
      .matches(
        /^(\+98|0098|98|0)?9\d{9}$/,
        "لطفا شماره موبایل را صحیح وارد نمایید"
      ),
  });

  function changeCityIds(e: any, value: any) {
    setCityIds(e);
    setCity(value);
  }

  const { mutate: getCitiesMutate } = useMutation(GetCities, {
    onSuccess: (data: GetCitiesResponse[]) => {
      if (data) {
        setCities(data);
      }
    },
    onError: () => {},
  });
  useEffect(() => {
    getCitiesMutate({});
  }, []);

  const handleAddUser = (values: any, { resetForm }: any) => {
    values.firstName = values.firstName.trim();
    values.lastName = values.lastName.trim();
    values.fullAccess = isFullAccess;
    values.cityTitle = city;
    values.cityId = cityIds;
    values.userId = Math.floor(Math.random() * 10000);

    setTempUsers([
      ...tempUsers!,
      {
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNo: values.mobileNo,
        fullAccess: isFullAccess,
        cityTitle: city,
        cityId: cityIds,
        userId: Math.floor(Math.random() * 10000),
      },
    ]);

    resetForm();
    if (checkboxRef.current) {
      if (isFullAccess) checkboxRef.current.click();
    }

    // if (keyState === 1) setKeyState(keyState + 1);
  };

  useEffect(() => {
    const arr: any = [];
    tempUsers.map((user) => {
      let { cityTitle, userId, ...newObj } = user;
      arr.push(newObj);
    });
    setNewUser(arr);
  }, [tempUsers]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleAddUser}
        validateOnMount={true}
        validationSchema={usersValidation}
      >
        {({
          handleSubmit,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid item marginBottom={"0px"}>
              <Box marginBottom={"20px"}>
                <Typography color={"#1D4A87"} fontSize={18} fontWeight={"bold"}>
                  فهرست کاربران
                </Typography>
              </Box>
              <Grid container columns={14} spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <MaterialTextFieldComponent
                    placeHolder={"نام"}
                    label={"نام"}
                    name={"firstName"}
                    id={"firstName"}
                    helperText={touched.firstName ? errors.firstName : ""}
                    error={touched.firstName && Boolean(errors.firstName)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <MaterialTextFieldComponent
                    placeHolder={"نام خانوادگی"}
                    label={"نام خانوادگی"}
                    name={"lastName"}
                    id={"lastName"}
                    onChange={handleChange}
                    helperText={touched.lastName ? errors.lastName : ""}
                    error={touched.lastName && Boolean(errors.lastName)}
                    onBlur={handleBlur}
                    value={values.lastName}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <MaterialTextFieldComponent
                    placeHolder={"شماره موبایل"}
                    label={"شماره موبایل"}
                    name={"mobileNo"}
                    id={"mobileNo"}
                    onChange={handleChange}
                    helperText={touched.mobileNo ? errors.mobileNo : ""}
                    error={touched.mobileNo && Boolean(errors.mobileNo)}
                    value={values.mobileNo}
                    onBlur={handleBlur}
                    required={true}
                    inputProps={{ maxLength: 11 }}
                    onKeyDown={(event) => {
                      if (event.code === "Space") {
                        event.preventDefault();
                      }
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={3}
                  className="supp-users-search"
                >
                  <AutoCompleteSearch
                    name={`city`}
                    id={`city`}
                    label="شهر محل فعالیت"
                    value={cityIds}
                    options={cities}
                    onChange={changeCityIds}
                    responseValue={city}
                    autocompleteKey={keyState}
                  />
                </Grid>
                <Grid item xs={0} sm={0} md={0} lg={2}></Grid>
                <Grid container columns={14} marginTop={"20px"}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={2}
                    className="suppliers-checkbox"
                  >
                    <CheckboxCmp
                      font="gap7"
                      checkboxRef={checkboxRef}
                      color="#1D4A87"
                      checkedColor="#1D4A87 !important"
                      title={"دسترسی کامل"}
                      onBtnClick={() => {
                        setFullAccess((prev) => !prev);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={1}>
                    <Button
                      sx={{ maxWidth: "150px", borderRadius: "5px !important" }}
                      fullWidth
                      type="submit"
                      variant="contained"
                      disabled={
                        !values.firstName ||
                        !values.lastName ||
                        !values.mobileNo ||
                        !cityIds
                      }
                      className={
                        !values.firstName ||
                        !values.lastName ||
                        !values.mobileNo ||
                        !cityIds
                          ? "btnForm disabledBtn"
                          : "btnForm SuccessDefault"
                      }
                    >
                      افزودن
                    </Button>
                  </Grid>
                  <Grid item xs={0} sm={0} md={0} lg={9}></Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>

      <Grid item marginBottom={"45px"}>
        {tempUsers.length > 0 && (
          <Box
            sx={{
              marginTop: "20px",
              // maxHeight: "120px",
              maxHeight: "calc(100vw / 22)",
              overflowY: "auto",
              paddingInline: "1px",
            }}
          >
            <Table
              sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
              aria-label="customized table"
            >
              <TableBody
                sx={{
                  outline: "1px solid #DAE0E4",
                }}
              >
                {tempUsers?.length !== 0 &&
                  tempUsers?.map((user: any) => (
                    <SupplierUsersTable
                      city={user.cityTitle}
                      userFirstname={user.firstName}
                      userLastname={user.lastName}
                      superUser={user.fullAccess}
                      // nationalCode={user.nationalCode}
                      // fullAccess={user.fullAccess}
                      mobileNo={user.mobileNo}
                      active={true}
                      citiesList={cities}
                      editModal={false}
                      deleteByService={false}
                      userId={user.userId}
                      delUserId={delUserId}
                      setDelUserId={setDelUserId}
                      setTempUsers={setTempUsers}
                      tempUsers={tempUsers}
                    />
                  ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Grid>
    </>
  );
};

export default SupplierUserForm;
